import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchSubscriptionById } from "../../apis/subscriptions-apis";
import { useParams } from "react-router-dom";
import { MessageInline } from "@able/react";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga4";
import { useSetBreadcrumbs } from "../../common/components/breadcrumbs/AbleBreadcrumbs";
import SubscriptionInformation from "./components/subscription-information-component";
import EnterpriseInfo from "./components/enterprise-info-component";
import LegalDisclaimer from "./components/legal-disclaimer-component";
import EnterpriseInfoSub from "./components/enterprise-info-sub-component";
import DownlinkThroughputChart from "./components/downlinkthroughput/downlink-throughput-chart-component";
import UplinkThroughputChart from "./components/uplinkthroughput/uplink-throughput-chart-component";
import MonthlyPerformanceCards from "./components/MonthlyPerformanceCards/MonthlyPerformanceCards";

import "./service-page-style.scss";

const ServicePage = () => {
    const { id } = useParams();
    const { data: subscriptionDetails, isLoading } = useQuery(["subscription", id], () => fetchSubscriptionById(id));

    useSetBreadcrumbs([
        { label: "Dashboard", to: "/" },
        { label: "Services", to: "/services" },
    ]);
    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Service Page" });
    }, [])

    return (
        <>
            <Helmet>
                <title>Service Performance - Telstra LANES</title>
            </Helmet>
            {!isLoading && (
                <>
                    {/* <ChartInformation subscriptionDetails={subscriptionDetails} /> */}
                    <SubscriptionInformation subscriptionDetails={subscriptionDetails}></SubscriptionInformation>
                    <MessageInline
                        variant="Information"
                        developmentUrl="/assets/able-sprites.svg"
                        description="Currently, we are investigating an issue relating to source data that will impact dashboard data.  There is no impact to your LANES service. This message will be removed when the issue is resolved, or will be updated as our investigation progresses."
                        className="message-box"
                        iconScreenReaderContent="Important performance information"
                    />
                    <MessageInline
                        variant="Information"
                        developmentUrl="/assets/able-sprites.svg"
                        description="4G usage only, 5G usage coming soon"
                        className="message-box"
                    >
                        <>
                            4G usage only, 5G usage coming soon <a href="#legal-disclaimer">*</a>
                        </>
                    </MessageInline>
                    <MonthlyPerformanceCards subscriptionId={subscriptionDetails.subscriptionId} />
                    <h2 className="throughput-type-info">Downlink throughput</h2>
                    <DownlinkThroughputChart subscriptionId={subscriptionDetails.subscriptionId} />
                    <h2 className="throughput-type-info">Uplink throughput</h2>
                    <UplinkThroughputChart subscriptionId={subscriptionDetails.subscriptionId} />
                    <LegalDisclaimer />
                    <EnterpriseInfo />
                </>
            )}

            {!isLoading && (
                <>
                    <EnterpriseInfoSub />
                </>
            )}
        </>
    );
};

export default ServicePage;
